/** Service Desk console: Service settings, bahagi B - SLA at mga calendar, Routing, mga Macro, Client portal, Notifications at timers, CSAT (SD-S1-47). */
export const serviceSettingsB = {
  nav: {
    sla: "SLA at mga calendar",
    routing: "Routing",
    macros: "Mga macro",
    portal: "Client portal",
    notifications: "Mga notification at timer",
    csat: "CSAT",
  },
  bkit: {
    save: "I-save ang mga pagbabago",
    discard: "Itapon",
    cancel: "Kanselahin",
    unsaved: "May mga pagbabago kang hindi pa na-save",
    list: {
      add: "Idagdag",
      empty: "Mag-type muna ng idadagdag.",
      none: "Wala pang naidagdag.",
      count: "{{count}} sa {{max}}",
      remove: "Alisin ang {{item}}",
      duplicate: "Nasa listahan na ang “{{item}}”.",
      full: "Puno na ang listahan: {{max}} ang pinakamarami.",
      added: "Naidagdag ang {{item}}.",
      removed: "Naalis ang {{item}}.",
    },
    errors: {
      plan: {
        policies: "Wala nang lugar sa plano mo para sa isa pang SLA policy. Mag-upgrade para magdagdag pa.",
        calendars: "Kasama ang mga business calendar sa planong Pro. Mag-upgrade para magdagdag.",
        rules: "Wala nang lugar sa plano mo para sa isa pang routing rule. Mag-upgrade para magdagdag pa.",
        skills: "Kasama ang skills routing sa planong Pro.",
        macros: "Wala nang lugar sa plano mo para sa isa pang macro. Mag-upgrade para magdagdag pa.",
      },
      calendarInUse_one: "{{count}} SLA policy pa ang nagbibilang ng mga target nito sa calendar na ito. Ilipat muna ito sa ibang calendar.",
      calendarInUse_other: "{{count}} SLA policy pa ang nagbibilang ng mga target nito sa calendar na ito. Ilipat muna ang mga ito sa ibang calendar.",
      policyInUse: "Ginagamit pa ng mga uri ng ticket o ng default ng workspace ang policy na ito. Pumili muna ng ibang policy para sa kanila.",
    },
    workflows: {
      open: "Buksan ang workflow",
      paused: "Naka-pause ang “{{name}}”, kaya walang gumagamit sa mga setting na ito hangga't hindi ito ipinagpapatuloy.",
      pausedChip: "Naka-pause",
      usedBy: "Ginagamit ng",
      ticket_unassigned_escalation: "I-escalate ang mga ticket na walang nakatalaga",
      ticket_waiting_reminder: "Paalalahanan ang mga kliyenteng may naghihintay na ticket",
      ticket_pending_auto_resolve: "I-resolve ang mga ticket na walang sumasagot",
      ticket_auto_close: "Isara ang mga naresolbang ticket",
      ticket_csat_request: "Humingi ng rating kapag naresolba",
      ticket_low_csat_alert: "Abisuhan ang team lead sa mababang rating",
    },
  },
  sla: {
    standardNote: "May 1 SLA policy ang Standard at nagbibilang ito ng mga target nang walang tigil. Kasama sa planong Pro ang maraming policy, ang mga business calendar na may holidays at ang mga contract SLA.",
    policies: "Mga SLA policy",
    new: "Bagong policy",
    newTitle: "Bagong SLA policy",
    newHint: "Nagsisimula ito sa mga sample na target (urgent: 1 oras para sumagot) na puwede mong baguhin agad.",
    create: "Gawin ang policy",
    created: "Nagawa ang policy na “{{name}}”.",
    name: "Pangalan ng policy",
    nameRequired: "Bigyan ng pangalan ang policy.",
    saved: "Na-save ang policy na “{{name}}”.",
    isDefault: "Default ng workspace",
    makeDefault: "Gawing default",
    defaultSet: "Ang “{{name}}” na ang default ng workspace.",
    usedBy_one: "{{count}} uri ng ticket ang gumagamit nito",
    usedBy_other: "{{count}} uri ng ticket ang gumagamit nito",
    delete: "Burahin",
    deleteTitle: "Burahin ang “{{name}}”?",
    deleteBody: "Nananatili ang due time ng mga ticket na gumagamit na nito. Hindi mabubura ang policy na ginagamit pa ng mga uri ng ticket o ng default ng workspace.",
    deleteConfirm: "Burahin ang policy",
    deleted: "Nabura ang policy na “{{name}}”.",
    emptyTitle: "Wala pang SLA policy",
    emptyBody: "Sinasabi ng policy kung gaano kabilis dapat makatanggap ng unang sagot at resolusyon ang ticket, ayon sa priority. Kung wala, walang SLA ang mga ticket.",
    matrix: {
      region: "Mga target ng SLA",
      caption: "Mga target sa oras ayon sa priority at orasan; iwanang walang laman ang cell kung walang target",
      priority: "Priority",
      none: "Walang target",
      cell: "{{priority}}: {{metric}} sa oras",
      hint: "Oras, binibilang sa bukas na oras ng calendar. Gumamit ng decimal para sa minuto (0.5 ay 30 minuto). Iwanang walang laman ang cell kung walang target.",
      invalid: "Gumamit ng bilang ng oras na higit sa 0 at hanggang 8,760 (isang taon), na may hanggang dalawang decimal.",
      needsFirst: "Magtakda ng kahit isang target sa unang sagot.",
      col: {
        first_response: "Unang sagot (oras)",
        next_response: "Susunod na sagot (oras)",
        resolution: "Resolusyon (oras)",
        onsite_response: "Pagdating on-site (oras)",
      },
      metric: {
        first_response: "unang sagot",
        next_response: "susunod na sagot",
        resolution: "resolusyon",
        onsite_response: "pagdating on-site",
      },
    },
    calendar: {
      label: "Business calendar",
      hint: "Ang bukas na oras lang ng calendar na ito ang binibilang ng mga target, at nilalaktawan ang mga holiday nito.",
      none: "Walang calendar: bilangin nang walang tigil",
      lockedTitle: "Kasama ang mga business calendar sa planong Pro",
      lockedBody: "Sa plano mo, nagbibilang ang mga target nang walang tigil. Mag-upgrade para oras-opisina lang ang bilangin at malaktawan ang mga holiday.",
      name: "Pangalan ng calendar",
      nameRequired: "Bigyan ng pangalan ang calendar.",
      timezone: "Time zone",
      timezoneHint: "Ginagamit ng mga petsa, due time ng SLA at mga ulat ang zone na ito.",
      usedBy_one: "{{count}} SLA policy ang nagbibilang dito",
      usedBy_other: "{{count}} SLA policy ang nagbibilang dito",
      save: "I-save ang calendar",
      saved: "Na-save ang calendar na “{{name}}”.",
      delete: "Burahin ang calendar",
      deleteTitle: "Burahin ang “{{name}}”?",
      deleteBody: "Mabubura ang lingguhang oras at mga holiday nito. Hindi mabubura ang calendar na binibilangan pa ng mga SLA policy.",
      deleteConfirm: "Burahin ang calendar",
      deleted: "Nabura ang calendar na “{{name}}”.",
      newTitle: "Bagong business calendar",
      newHint: "Itakda ang lingguhang bukas na oras. Isusunod ang mga holiday.",
      create: "Gawin ang calendar",
      created: "Nagawa ang calendar na “{{name}}”.",
      seedLabel: "Simulan ang listahan ng holiday sa mga holiday sa Pilipinas ng 2026 at 2027",
      seedHint: "Mga regular at special na non-working day. Puwede mo pa ring baguhin ang bawat isa.",
    },
    warn: {
      label: "Magbabala kapag lumipas na ang bahaging ito ng target",
      hint: "Nagiging babala ang mga chip sa bahaging ito at nagiging panganib kapag paubos na ang oras. Karaniwang 75%.",
    },
    preview: {
      title: "I-preview ang due date",
      priority: "Priority",
      metric: "Orasan",
      created: "Nagawa ang ticket",
      noTarget: "Mag-type ng oras para sa priority at orasang ito sa matrix para makita kung kailan magiging due ang ticket.",
      failed: "Hindi available ang preview ngayon. Walang nabago sa matrix.",
      moment: {
        friday: "Susunod na Biyernes 16:30",
        wednesday: "Susunod na Miyerkules 09:30",
        beforeHoliday: "Isang araw bago ang {{holiday}}, 16:00",
        now: "Ngayon na",
      },
    },
    calendars: {
      title: "Mga business calendar",
      intro: "Ang mga bukas na oras at holiday na pinagbibilangan ng mga target ng SLA.",
      new: "Bagong calendar",
      pick: "Calendar",
      emptyTitle: "Wala pang business calendar",
      emptyBody: "Gumawa ng isa para oras ng trabaho lang ng team mo ang bilangin ng mga target at malaktawan ang mga holiday.",
      lockedTitle: "Kasama ang mga business calendar sa planong Pro",
      lockedBody: "Sa plano mo, nagbibilang ang mga target nang walang tigil. Mag-upgrade para sa lingguhang oras, time zone at listahan ng holiday.",
    },
    week: {
      title: "Lingguhang bukas na oras",
      copyMonday: "Kopyahin ang Lunes sa Martes hanggang Biyernes",
      open: "Bukas ang {{day}}",
      closed: "Sarado",
      from: "{{day}}: bukas ng",
      to: "{{day}}: sarado ng",
      addSpan: "Magdagdag ng oras sa {{day}}",
      removeSpan: "Alisin ang mga oras na ito sa {{day}}",
      neverOpen: "Magbukas ng kahit isang araw: walang mabibilang ang calendar na hindi kailanman bukas.",
      problem: {
        order: "{{day}}: dapat mas maaga ang bawat oras ng pagbubukas kaysa sa pagsasara.",
        overlap: "{{day}}: nag-ooverlap ang mga bukas na oras. Gawing isang tuloy-tuloy o mag-iwan ng pagitan.",
      },
    },
    days: {
      mon: "Lunes",
      tue: "Martes",
      wed: "Miyerkules",
      thu: "Huwebes",
      fri: "Biyernes",
      sat: "Sabado",
      sun: "Linggo",
    },
    holidays: {
      title: "Mga holiday",
      intro: "Mga araw na sarado ang “{{calendar}}”. Puwedeng simulan ito ng listahan ng Pilipinas ng 2026 at 2027; baguhin kapag may bagong proklamasyon.",
      seed: "Idagdag ang Pilipinas 2026-2027",
      seeded_one: "Nakadagdag ng {{count}} holiday.",
      seeded_other: "Nakadagdag ng {{count}} holiday.",
      emptyTitle: "Walang holiday",
      emptyBody: "Itinuturing na araw ng trabaho ang bawat araw sa calendar na ito. Idagdag ang mga holiday sa Pilipinas o maglagay ng sarili mo.",
      regular: "Regular",
      special: "Special",
      addTitle: "Magdagdag ng holiday",
      editing: "I-edit ang holiday",
      date: "Petsa",
      name: "Pangalan",
      specialLabel: "Special non-working day",
      specialHint: "Itinakda ng batas ang mga regular na holiday; taun-taong ipinoproklama ang mga special na araw.",
      add: "Idagdag ang holiday",
      saveOne: "I-save ang holiday",
      added: "Naidagdag ang holiday na “{{name}}”.",
      updated: "Na-update ang holiday na “{{name}}”.",
      removed: "Naalis ang holiday na “{{name}}”.",
      edit: "I-edit ang {{name}}",
      remove: "Alisin ang {{name}}",
      problem: {
        dateRequired: "Pumili ng petsa.",
        nameRequired: "Pangalanan ang holiday.",
        nameLong: "Gumamit ng 80 character o mas kaunti.",
        duplicate: "Holiday na ang petsang ito.",
        full: "Hanggang 150 holiday lang ang calendar.",
      },
    },
    precedence: {
      title: "Aling policy ang nalalapat",
      asset_contract: "Aktibong kontratang sumasaklaw sa kagamitan ng ticket: ang policy nito.",
      organisation_contract: "Aktibong kontrata ng organisasyon ng kliyente: ang policy nito.",
      ticket_type: "Ang sariling policy ng uri ng ticket.",
      workspace_default: "Ang default na policy ng workspace.",
      none: "Kung wala, walang SLA ang ticket.",
    },
  },
  routing: {
    title: "Mga routing rule",
    new: "Magdagdag ng rule",
    newTitle: "Magdagdag ng routing rule",
    editTitle: "I-edit ang routing rule",
    formHint: "Sinasabi ng rule kung anong mga ticket ang kukunin nito, aling team ang makakakuha at paano pipili ng tao.",
    create: "Idagdag ang rule",
    save: "I-save ang rule",
    created: "Naidagdag ang rule na “{{name}}”.",
    updated: "Na-save ang rule na “{{name}}”.",
    deleted: "Nabura ang rule na “{{name}}”.",
    emptyTitle: "Wala pang routing rule",
    emptyBody: "Kung walang rule, maghihintay na walang nakatalaga ang mga bagong ticket. Magdagdag ng rule para sa bawat uri ng ticket, at isang huling rule na walang kondisyon para sa lahat ng iba pa.",
    listLabel: "Mga routing rule, panalo ang unang tumugma",
    footFirst: "Panalo ang unang rule na tumugma.",
    footPlain: "{{count}} rule.",
    footLimited: "{{count}} sa {{limit}} rule sa plano mo.",
    footUnlimited: "{{count}} rule; walang limit sa plano mo.",
    noFallback: "Walang aktibong rule na tumutugma sa lahat ng ticket. Mananatiling walang nakatalaga ang mga ticket na walang tinutugmaang rule: magdagdag ng huling rule na walang kondisyon para sa lahat ng iba pa.",
    when: "Kapag",
    then: "Pagkatapos",
    always: "lahat ng ticket",
    unknownTeam: "hindi kilalang team",
    off: "Naka-off",
    on: "Naka-on",
    activeAria: "Naka-on ang rule na {{name}}",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    deleteAria: "Burahin ang {{name}}",
    editSkillsAria: "I-edit ang mga skill ni {{name}}",
    deleteTitle: "Burahin ang “{{name}}”?",
    deleteBody: "Nananatili ang nakatalaga sa mga ticket na na-route nito. Lilipat sa susunod na rule na tutugma ang mga bagong ticket.",
    deleteConfirm: "Burahin ang rule",
    name: "Pangalan ng rule",
    nameRequired: "Pangalanan ang rule.",
    team: "Ipatalaga sa team",
    teamChoose: "Pumili ng team",
    teamRequired: "Piliin ang team na makakakuha ng mga ticket na ito.",
    noTeams: "Wala pang team. Gumawa muna ng team sa Settings.",
    method: "Paano pipili ng tao",
    person: "Tao",
    personChoose: "Pumili ng tao",
    personRequired: "Piliin ang taong makakakuha ng mga ticket na ito.",
    skills: "Mga kailangang skill",
    skillsHint: "Kailangang taglay ng miyembro ang lahat ng nakalista. Maliliit na titik, numero at underscore.",
    skillsPlaceholder: "water_systems",
    skillInvalid: "Magsimula sa titik at gumamit ng maliliit na titik, numero at underscore (hanggang 40 character).",
    skillsLockTitle: "Kasama ang skills matching sa planong Pro",
    skillsLockBody: "Kasama sa plano mo ang round robin, least open at ang team queue.",
    priority: "Itakda ang priority sa",
    priorityKeep: "Panatilihin ang priority ng ticket",
    priorityHint: "Opsyonal: ito ang magiging priority ng tumutugmang ticket.",
    setsPriority: "Nagtatakda ng priority na {{priority}}",
    tags: "Mga tag na idadagdag",
    tagsHint: "Opsyonal: ilalagay ang mga tag na ito sa mga tumutugmang ticket.",
    tagInvalid: "Gumamit ng 1 hanggang {{max}} character.",
    active: "Naka-on ang rule",
    activeHint: "Lalaktawan pero itatago ang rule na naka-off.",
    yes: "Oo",
    no: "Hindi",
    builder: {
      title: "Kapag tumugma ang ticket",
      hint: "Dapat totoo ang lahat ng kondisyon ng isang grupo. Magdagdag ng isa pang grupo para sa ibang kaso (o).",
      always: "Walang kondisyon: tumutugma ang rule na ito sa lahat ng ticket. Maglagay ng ganito sa dulo, para sa lahat ng iba pa.",
      group: "Grupo {{n}}",
      or: "o",
      andWord: "at",
      orWord: "o",
      name: "kondisyon {{n}} ng grupo {{group}}",
      factOf: "Fact ng {{name}}",
      opOf: "Operator ng {{name}}",
      valueOf: "Halaga ng {{name}}",
      valuesOf: "Mga halaga ng {{name}}",
      remove: "Alisin ang {{name}}",
      addCondition: "Magdagdag ng kondisyon",
      addAnd: "Magdagdag ng kondisyon sa grupong ito (at)",
      addGroup: "Magdagdag ng isa pang grupo (o)",
      noValue: "Walang kailangang halaga.",
      choose: "Pumili",
      pickOne: "Mag-tick ng kahit isa.",
      typeValue: "Mag-type ng halaga.",
      valueInvalid: "Mag-type ng maikling halaga.",
    },
    facts: {
      ticket_type: "Uri ng ticket",
      ticket_category: "Kategorya ng uri",
      ticket_priority: "Priority",
      ticket_channel: "Channel",
      ticket_origin: "Paano ginawa",
      ticket_language: "Wika",
      ticket_tags: "Mga tag",
      ticket_keywords: "Mga salita sa pamagat o teksto",
      ticket_created_in_office_hours: "Ginawa sa oras-opisina",
      ticket_requester_verified: "Verified ang kliyente",
      ticket_ai_topic: "Paksang nakita ng assistant",
      ticket_org_tier: "Tier ng organisasyon",
      organisation_tier: "Tier ng organisasyon (record)",
      organisation_industry: "Industriya ng organisasyon",
      organisation_tags: "Mga tag ng organisasyon",
      ticket_site_region: "Rehiyon ng site",
      ticket_asset_category: "Kategorya ng kagamitan",
      ticket_has_asset: "May kagamitan",
      ticket_contract_active: "May aktibong kontrata",
    },
    ops: {
      is: "ay",
      is_not: "ay hindi",
      is_any_of: "ay alinman sa",
      is_none_of: "ay wala sa",
      contains: "naglalaman ng",
      not_contains: "hindi naglalaman ng",
      contains_any_of: "naglalaman ng alinman sa",
      starts_with: "nagsisimula sa",
      is_set: "may halaga",
      is_not_set: "walang halaga",
      gt: "ay higit sa",
      lt: "ay mas mababa sa",
    },
    channels: {
      widget: "Widget ng website",
      webapp: "Web app",
      mobile: "Mobile app",
      messenger: "Messenger",
      email: "E-mail",
      api: "API",
      console: "Console",
    },
    origins: {
      ai_intake: "Intake ng assistant",
      client_form: "Form ng kliyente",
      staff: "Staff",
      email: "E-mail",
      api: "API",
      workflow: "Workflow",
      conversation: "Usapan",
      handoff: "Handoff",
      order_issue: "Problema sa order",
      visit: "Pagbisita sa field",
      punch_list: "Punch list",
      pm_plan: "Plano ng maintenance",
    },
    languages: { en: "English", fil: "Filipino" },
    methods: {
      round_robin: { name: "Round robin", hint: "Salitan ang mga available na miyembro." },
      least_open: { name: "Pinakakaunting bukas na ticket", hint: "Ang available na miyembrong pinakakaunti ang bukas na ticket." },
      skills_match: { name: "Skills match", hint: "Miyembrong may lahat ng kailangang skill; kapag pantay, ang hindi gaanong abala." },
      none: { name: "Team queue", hint: "Walang pinapangalanan; maghihintay ang ticket sa queue ng team." },
      user: { name: "Isang partikular na tao", hint: "Laging iisang miyembro." },
    },
    test: {
      title: "Subukan ang routing",
      intro: "Aling rule ang kukuha sa ticket na ito? Walang mababago.",
      mode: "Ano ang susubukan",
      sample: "Ilarawan ang ticket",
      ticket: "Isang kasalukuyang ticket",
      number: "Numero ng ticket",
      numberHint: "Halimbawa, KHA-10001.",
      numberInvalid: "Gumamit ng numero ng ticket tulad ng KHA-10001.",
      type: "Uri ng ticket",
      typeRequired: "Pumili ng uri ng ticket.",
      priority: "Priority",
      channel: "Channel",
      language: "Wika",
      hours: "Ginawa",
      hoursAuto: "Ngayon (orasan ang magpapasya)",
      hoursIn: "Sa loob ng oras-opisina",
      hoursOut: "Pagkatapos ng oras-opisina",
      tags: "Mga tag",
      tagsHint: "Paghiwalayin ng kuwit.",
      assetCategory: "Kategorya ng kagamitan",
      run: "Subukan ang routing",
      matches: "Tumutugma sa rule {{number}}: {{name}}.",
      goes: "Mapupunta sa {{team}} sa pamamagitan ng {{method}}.",
      assignee: "Nakatalaga kay {{name}}.",
      none: "Walang tumutugmang rule ({{count}} ang tiningnan). Mananatili ang ticket sa queue na walang nakatalaga.",
      facts: "Mga fact na tiningnan ng mga rule",
      notes: {
        team_queue: "Walang pinangalanan: maghihintay ang ticket sa queue ng team.",
        no_eligible_member: "Walang makakakuha nito ngayon sa team (wala o walang access sa ticket), kaya maghihintay ito sa queue.",
        no_skilled_member: "Walang miyembro ng team na may lahat ng kailangang skill, kaya maghihintay ito sa queue.",
        at_capacity: "Puno na ang lahat ng makakakuha nito, kaya maghihintay ito sa queue.",
        user_unavailable: "Wala o hindi makakakuha ng ticket ang pinangalanang tao, kaya maghihintay ito sa queue.",
      },
    },
    skillsTitle: "Mga skill ng miyembro",
    skillsIntro: "Ibinibigay ng skills match ang ticket sa miyembrong may lahat ng skill na hinihingi ng rule.",
    skillsFailed: "Hindi na-load ang mga skill. Subukan ulit mamaya.",
    noMembers: "Walang miyembrong maipapakita.",
    noSkills: "Walang skill",
    skillsDialog: "Mga skill ni {{name}}",
    skillsDialogHint: "Maliliit na salita tulad ng water_systems o billing.",
    skillsSaved: "Na-save ang mga skill ni {{name}}.",
  },
  macros: {
    new: "Bagong macro",
    newTitle: "Bagong macro",
    editTitle: "I-edit ang macro",
    formHint: "Sagot na isinisingit ng agent sa isang click, at puwede ring magbago sa ticket nang sabay.",
    create: "Gawin ang macro",
    save: "I-save ang macro",
    saved: "Na-save ang macro na “{{name}}”.",
    search: "Maghanap ng macro",
    searchPlaceholder: "Maghanap ng macro",
    filter: "Sino ang nakakakita ng macro",
    scopes: { all: "Lahat", personal: "Akin", team: "Team", workspace: "Workspace" },
    scopeHint: {
      personal: "Ikaw lang ang nakakakita.",
      team: "Nakikita ito ng mga miyembro ng team.",
      workspace: "Nakikita ito ng lahat ng nagtatrabaho sa mga ticket.",
    },
    scope: "Sino ang nakakakita",
    team: "Team",
    teamRequired: "Piliin ang team.",
    listLabel: "Mga macro",
    emptyTitle: "Wala pang macro",
    emptyBody: "Isulat nang minsan ang mga sagot na paulit-ulit mong ipinapadala, na may pangalan ng kliyente na kusang napupunan.",
    noMatchTitle: "Walang tumutugmang macro",
    noMatchBody: "I-clear ang paghahanap o ang filter, o magsulat ng bagong macro.",
    clear: "I-clear ang paghahanap",
    titleLabel: "Pangalan",
    titleRequired: "Pangalanan ang macro (hanggang 120 character).",
    shortcut: "Shortcut",
    shortcutHint: "Opsyonal. I-type ito pagkatapos ng / sa composer, halimbawa /warranty.",
    shortcutInvalid: "Titik, numero, / _ at - lang ang gamitin (hanggang 40).",
    bodyEn: "Sagot (English)",
    bodyFil: "Sagot (Filipino)",
    bodyFilHint: "Opsyonal. Para sa mga kliyenteng nagsusulat sa Filipino; babalik sa English kapag walang laman.",
    bodyProblem: {
      empty: "Isulat ang sagot o magdagdag ng aksyon.",
      braces: "May variable na kulang ang pangsarang braces (}}).",
      long: "Masyadong mahaba ang sagot (hanggang 10,000 character).",
    },
    noText: "Walang teksto ng sagot",
    hasFil: "Filipino",
    noActions: "Sagot lang",
    used_one: "Nagamit nang {{count}} beses",
    used_other: "Nagamit nang {{count}} beses",
    readOnly: "Shared: manager ang nag-eedit",
    edit: "I-edit",
    editAria: "I-edit ang {{name}}",
    delete: "Burahin",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang “{{name}}”?",
    deleteBody: "Hindi na ito makikita ng mga agent sa composer. Walang mababago sa mga ticket na gumamit nito.",
    deleteConfirm: "Burahin ang macro",
    deleted: "Nabura ang macro na “{{name}}”.",
    variables: {
      title: "Magsingit ng variable",
      insert: "Isingit ang {{variable}}",
      group: {
        ticket: "Ticket",
        contact: "Contact",
        organisation: "Organisasyon",
        agent: "Agent",
        workspace: "Workspace",
        asset: "Kagamitan",
        visit: "Pagbisita",
      },
    },
    actions: {
      title: "Pagkatapos, sa ticket",
      hint: "Tumatakbo ang mga aksyon kapag inilapat ng agent ang macro. Opsyonal ang bawat isa.",
      none: "Walang aksyon: sagot lang ang isinusulat ng macro.",
      add: "Magdagdag ng aksyon",
      addButton: "Idagdag ang aksyon",
      remove: "Alisin ang aksyon: {{action}}",
      type: {
        set_status: "Itakda ang status",
        set_priority: "Itakda ang priority",
        set_type: "Palitan ang uri ng ticket",
        add_tags: "Magdagdag ng mga tag",
        remove_tags: "Mag-alis ng mga tag",
        assign: "Italaga",
        add_note: "Magdagdag ng internal note",
        set_field: "Itakda ang isang field",
      },
      label: {
        set_status: "Itakda ang status: {{value}}",
        set_priority: "Itakda ang priority: {{value}}",
        set_type: "Palitan ang uri: {{value}}",
        add_tags: "Magdagdag ng tag: {{value}}",
        remove_tags: "Mag-alis ng tag: {{value}}",
        assign: "Italaga kay {{value}}",
        add_note: "Magdagdag ng note",
        set_field: "Itakda ang field na {{value}}",
      },
      status: "Status",
      statusChoose: "Pumili ng status",
      code: "Resolution code",
      codeHint: "Opsyonal. Kailangan ng code ang naresolbang ticket; ito ang gagamitin.",
      codeNone: "Walang code",
      priority: "Priority",
      typeLabel: "Uri ng ticket",
      typeChoose: "Pumili ng uri",
      tagsAdd: "Mga tag na idadagdag",
      tagsRemove: "Mga tag na aalisin",
      team: "Team",
      person: "Tao",
      leave: "Iwanan kung ano ito",
      nobody: "Walang tao (alisin ang nakatalaga)",
      note: "Internal note",
      noteHint: "Hindi ito nakikita ng mga kliyente. Puwede nitong gamitin ang parehong mga variable ng sagot.",
      kept: "Pinananatili ang aksyong ito kung ano ito; i-edit ito sa API.",
      problem: {
        status: "Pumili ng status.",
        type: "Pumili ng uri ng ticket.",
        tags: "Magdagdag ng kahit isang tag.",
        assign: "Pumili ng team o tao.",
        note: "Isulat ang note.",
      },
    },
    preview: {
      title: "Preview",
      language: "Wika ng preview",
      ticket: "Punan gamit ang isang ticket (opsyonal)",
      ticketHint: "Ipinapakita ng numero ng ticket tulad ng KHA-10001 ang sagot na may mga halaga ng ticket na iyon.",
      unknown: "Hindi umiiral ang mga variable na ito at mananatiling walang laman: {{variables}}",
    },
  },
  portal: {
    shownTitle: "Ang nakikita ng mga kliyente",
    shownIntro: "Sinusubaybayan ng mga kliyente mo ang kanilang mga ticket sa My tickets sa website, web app at mobile app. Piliin kung ano ang makikita nila sa bawat ticket.",
    priority: {
      label: "Ipakita ang priority sa mga kliyente",
      hint: "Naka-off: status lang ang nakikita ng mga kliyente, hindi kailanman ang Urgent, High, Normal o Low.",
    },
    names: {
      label: "Ipakita ang mga unang pangalan ng staff",
      hint: "Naka-off: pangalan ng team ang mababasa sa mga sagot at pagtatalaga, halimbawa “Support team”.",
    },
    assignee: {
      label: "Ipakita kung kanino nakatalaga ang ticket",
      hint: "Naka-off: nakikita ng mga kliyente ang mga sagot pero hindi kung sino ang may hawak ng ticket.",
    },
    neverShown: "Hindi kailanman nakikita ng mga kliyente ang mga internal note, kung na-breach ang SLA, o ang mga uri ng ticket na back office.",
    saved: "Na-save ang mga setting ng client portal.",
    preview: {
      label: "Preview ng kliyente",
      title: "Preview ng kliyente",
      heading: "Aking mga ticket",
      ticket: "KHA-10419 · Hindi nag-i-scan ang printer",
      sample: "Huling update ngayong araw",
      assigned: "Nakatalaga kay {{who}}",
      reply: "Ipinadala namin ang quote ng technician para makumpirma mo.",
      staffNamed: "Ana mula sa Support team",
      team: "Support team",
    },
    behaviour: {
      title: "Paano kumikilos ang portal",
      org: "Nakikita rin ng mga admin ng organisasyon ang bawat ticket ng kanilang organisasyon; ang iba pang contact ay nakikita ang sarili nila at ang mga ibinahagi sa kanila.",
      magic: "Puwedeng mag-sign in ang mga kliyente gamit ang link sa e-mail na valid sa loob ng {{minutes}} minuto at isang beses lang magagamit.",
      reopen: "Puwedeng buksan ulit ng kliyente ang naresolbang ticket hanggang kusa itong magsara, {{days}} araw matapos maresolba.",
      internal: "Nasa panig ng staff ang mga ticket na back-office o tracker at ang mga internal note.",
      language: "Sumasagot ang assistant sa wikang ginagamit ng kliyente; sumusunod ang portal sa wika ng kliyente.",
    },
    share: {
      title: "Mga grupo at branding",
      groups: "Itinatakda sa bawat uri ng ticket ang mga grupong nakikita ng kliyente kapag gumagawa ng ticket (Problems, Requests, Orders & billing, Feedback).",
      branding: "Ginagamit ng portal ang pangalan, logo at kulay ng workspace mo mula sa mga setting ng workspace.",
      typesLink: "Buksan ang mga uri ng ticket",
      brandingLink: "Buksan ang mga setting ng workspace",
    },
  },
  notifications: {
    staff: {
      title: "Ang mga notification mo",
      caption: "Mga Service notification na natatanggap mo, ayon sa channel",
      intro: "Piliin kung aling mga Service event ang gusto mong malaman at saan. Para sa iyo ito sa workspace na ito.",
      event: "Event",
      on: "Naka-on",
      saved: "Na-save ang mga Service notification mo.",
      failed: "Hindi na-load ang mga napili mong notification. Subukan ulit mamaya.",
      emptyTitle: "Walang Service notification na itatakda",
      emptyBody: "Lalabas ang mga ito rito kapag naka-on na ang Service Desk sa workspace mo.",
    },
    types: {
      ticket_new: { name: "Bagong ticket sa team ko", hint: "May dumating na ticket sa team na kinabibilangan mo." },
      ticket_assigned: { name: "May ticket na itinalaga sa akin", hint: "May tao o rule na nagbigay sa iyo ng ticket." },
      ticket_client_replied: { name: "Sumagot ang kliyente", hint: "Sumagot ang kliyente sa ticket na hawak mo." },
      ticket_mention: { name: "Na-mention ako sa note", hint: "Ni-@mention ka ng kasamahan mo sa internal note." },
      ticket_sla: { name: "Malapit na o lumampas na ang SLA", hint: "Malapit nang hindi maabot ang target, o hindi na naabot." },
      ticket_csat_low: { name: "Mababang rating ng satisfaction", hint: "Mababa ang rating ng kliyente sa ticket." },
      ticket_returned_to_queue: { name: "Bumalik sa queue ang ticket", hint: "Umalis ang isang miyembro at bumalik sa team ang mga ticket niya." },
      order_placed: { name: "May na-place na order", hint: "May kliyenteng nag-order sa pamamagitan ng assistant." },
      order_issue: { name: "May problema ang isang order", hint: "May ticket na ginawa tungkol sa order." },
      order_sync_failed: { name: "Hindi naipadala ang isang order", hint: "Hindi tinanggap ng order system ang isang order." },
      order_approval: { name: "May order na naghihintay ng approval", hint: "Kailangan ng desisyon ang isang order." },
      visit_scheduled: { name: "May na-schedule na pagbisita", hint: "May field visit na na-book para sa iyo o sa team mo." },
      visit_changed: { name: "May nabagong pagbisita", hint: "Inilipat o kinansela ang isang pagbisita." },
      asset_due: { name: "Due na ang serbisyo ng kagamitan", hint: "Malapit na ang maintenance, calibration o warranty." },
      connector_health: { name: "May connector na hindi maayos", hint: "Huminto ang link sa sistema ng kliyente." },
    },
    timers: {
      title: "Mga timer",
      intro: "Kailan ie-escalate ang ticket, kailan paaalalahanan ang kliyente, at kailan kusang mare-resolve at magsasara ang ticket.",
      saved: "Na-save ang mga timer.",
      unassigned: {
        label: "I-escalate ang ticket na walang nakatalaga pagkalipas ng (minuto)",
        hint: "Oras-opisina lang ang binibilang.",
      },
      reminders: {
        label: "Paalalahanan ang kliyenteng hindi pa sumasagot pagkalipas ng (araw)",
        hint: "Hanggang {{max}} paalala, mula {{from}} hanggang {{to}} araw matapos magsimulang maghintay ang ticket.",
        placeholder: "3",
      },
      autoResolve: {
        label: "I-resolve ang ticket na hindi kailanman sinagot ng kliyente pagkalipas ng (araw)",
        hint: "Ang 0 ay hindi kailanman kusang magre-resolve. Mare-resolve ito gamit ang code na “No response from client”.",
      },
      autoClose: {
        label: "Isara ang naresolbang ticket pagkalipas ng (araw)",
        hint: "Puwede itong buksan ulit ng kliyente hanggang sa panahong iyon.",
      },
      problem: {
        number: "Maglagay ng buong bilang.",
        range: "Gumamit ng bilang mula {{min}} hanggang {{max}}.",
        count: "Hanggang 3 paalala lang.",
      },
    },
    digest: {
      title: "Labas ng oras-opisina",
      staff: "Ang staff e-mail na nagawa habang sarado ang opisina ay maghihintay sa isang digest sa umaga (hanggang {{lines}} linya) sa halip na ipadala sa gabi. Hindi ipinagpapaliban ang mga in-app notification.",
      clients: "Ine-e-mail ang mga kliyente anumang oras. Ang ilang sagot sa iisang ticket sa loob ng {{minutes}} minuto ay sabay na ipapadala sa iisang e-mail.",
      hoursCalendar: "Ang oras-opisina ay ang bukas na oras ng “{{name}}” ({{zone}}), ang calendar ng default na SLA policy.",
      hoursDefault: "Walang calendar sa default na SLA policy, kaya ang oras-opisina ay Lunes hanggang Biyernes, 08:00 hanggang 17:00.",
      hoursLink: "Buksan ang SLA at mga calendar",
    },
  },
  csat: {
    surveyTitle: "Survey ng satisfaction",
    surveyIntro: "Kapag naresolba ang ticket, hihilingin sa kliyente na i-rate ito mula 1 hanggang 5 star.",
    stateOn: "Naka-on ang mga survey",
    statePaused: "Naka-pause ang mga survey",
    stateOff: "Naka-off ang mga survey",
    enabled: {
      label: "Hilingin ang rating ng nag-request kapag naresolba ang ticket",
      hint: "Kapag pinatay, walang hihilingan; naresolba pa rin ang mga ticket gaya ng dati. Hindi ipinapadala para sa back-office o tracker na ticket, o para sa mga resolusyong nakalista sa ibaba.",
    },
    pausedNote: "Naka-pause ang workflow na humihingi ng rating, kaya walang survey na ipinapadala.",
    pausedLink: "Buksan ang workflow",
    fatigue: {
      label: "Itanong sa iisang contact nang hindi hihigit sa isang beses kada (araw)",
      hint: "Mula {{min}} hanggang {{max}}. Pinapatay ng 0 ang limit.",
      problem: {
        number: "Maglagay ng buong bilang.",
        range: "Gumamit ng bilang mula {{min}} hanggang {{max}}.",
      },
    },
    alert: {
      label: "Abisuhan ang team lead kapag kapantay o mas mababa sa (star)",
      hint: "Mula {{min}} hanggang {{max}}. Maaabisuhan ang team lead at ang assignee sa ganitong kababang rating.",
      problem: {
        number: "Maglagay ng buong bilang.",
        range: "Gumamit ng bilang mula {{min}} hanggang {{max}}.",
      },
    },
    lowAlert: "Inaabisuhan ang team lead at ang assignee kapag kapantay o mas mababa sa antas na ito ang rating.",
    recent: {
      title: "Mga kamakailang rating",
      ticket: "Ticket",
      contact: "Contact",
      score: "Score",
      reason: "Dahilan at komento",
      when: "Kailan",
      outOf: "{{score}} mula sa 5",
      low: "Naabisuhan",
      erased: "Binurang contact",
      noComment: "Walang komento",
      emptyTitle: "Wala pang rating",
      emptyBody: "Lalabas dito ang mga rating habang sinasagot ng mga kliyente ang survey pagkatapos maresolba ang ticket.",
    },
    reasonsTitle: "Mga dahilan para sa 1 hanggang {{score}} star",
    reasonsIntro: "Pipili ang kliyenteng nagbigay ng {{score}} star o mas mababa ng isa sa mga dahilang ito at puwedeng magdagdag ng komento.",
    reasonsEmptyTitle: "Wala pang dahilan",
    reasonsEmptyBody: "Idagdag ang mga dahilang puwedeng piliin ng kliyente, tulad ng “Natagalan”.",
    reasonsList: "Mga dahilan",
    addReason: "Magdagdag ng dahilan",
    reasonEn: "Dahilan {{n}} (English)",
    reasonFil: "Dahilan {{n}} (Filipino)",
    removeReason: "Alisin ang dahilang {{name}}",
    reasonProblem: {
      required: "Isulat ang dahilan sa English.",
      long: "Gumamit ng {{max}} character o mas kaunti.",
      duplicate: "Nasa listahan na ang dahilang ito.",
    },
    saved: "Na-save ang mga setting ng CSAT.",
    exclusionsTitle: "Walang survey kapag",
    exclusionsTypes: "Hindi kailanman sinasarbey ang mga ticket ng uring back-office at tracker.",
    exclusionsList: "Mga resolution code na lumalaktaw sa survey",
    skipped: "Walang survey",
    skipAria: "Walang survey kapag naresolba bilang {{name}}",
    preview: {
      label: "Preview ng survey",
      title: "Ang nakikita ng kliyente",
      question: "Kumusta kami sa {{number}}?",
      stars: "Limang star na mapagpipilian",
      low: "Sa {{score}} star o mas mababa, pipili ang kliyente ng dahilan at puwedeng magdagdag ng komento.",
    },
  },
} as const;
